module.exports = __webpack_public_path__ + "static/media/logo-klapp.b80aefd5.svg";